import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 1470. 見積タスク削除
 * [DELETE] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/quotation_tasks/:quotation_task_id
 */
type Props = {
  identifier: string;
  team_id: number;
  sales_order_id: number;
  id: number;
};

const destroyQuotationTask = (props: Props) => {
  return axios.delete(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.sales_order_id}/quotation_tasks/${props.id}`
  );
};

export const useDestroyQuotationTask = () => {
  return useMutation({
    mutationFn: destroyQuotationTask
  });
};
